import { render, staticRenderFns } from "./ChannelsList.vue?vue&type=template&id=94a27bd2&"
import script from "./ChannelsList.vue?vue&type=script&lang=js&"
export * from "./ChannelsList.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsList.vue?vue&type=style&index=0&id=94a27bd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports